import React from "react";
import Router from "./routes/Router";
import { createRoot } from "react-dom/client";
import PersistentRecoil from "./components/PersistentRecoil";
import GlobalLoadingOverlay from "./components/GlobalLoadingOverlay";
import { setupAxiosLoadingInterceptors } from "./utils/axiosLoading";

import "./styles/reset.css";
import "./css/index.scss";

const root = createRoot(document.getElementById("root"));
setupAxiosLoadingInterceptors();
root.render(
  <React.StrictMode>
    <PersistentRecoil>
      <GlobalLoadingOverlay />
      <Router />
    </PersistentRecoil>
  </React.StrictMode>,
);
